// extracted by mini-css-extract-plugin
export default {"root":"IconNetwork_root__aeEQM"};